import { BaseModel } from './BaseModel';

export interface ILinkProps {
    title: string;
    link: string;
}
export interface IModuleModelProps {
    id?: string;
    Description?: string;
    ModuleID?: string;
    Name?: string;
    MinimumMarksToPass?: string;
    TrainingDuration?: string;
    Category?: string;
    SubCategory?: string;
    UniqueId?: string;
    DateCreated?: string;
    DueDate?: string;
    ContinueLater?: boolean;
    DateCompleted?: any;
    CompletedDate?: any;
    CompletedStatus?: string;
    Expired ?: string;
    ParentId?: string;
    ModuleId?: string;
    ModuleType?: string;
    Instructions?: string;
    Links?: ILinkProps[];
    Questions?: {
        answer?: any;
        Choices?: any;
        questionNum?: number;
        question?: string;
        CorrectAnswer?: string;
    }[];
    Completed?: boolean;
}

export class ModuleModel extends BaseModel<IModuleModelProps> {
    constructor(props: IModuleModelProps) {
        super(props);
    }

    public static get(id: string) {
        return ModuleModel.getSingleInstance<IModuleModelProps>(id);
    }

    public static list() { 
        return ModuleModel.listAll<IModuleModelProps>();
    }
    public static resource: string = 'module';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/ModuleModel.ts